<template>
  <div class="knowledge-project-box">
    <div class="knowledge-project-tag">
      <span
        :class="{ active: projectCategory === null }"
        @click="categoryTag(null)"
        >全部</span
      >
      <span
        v-for="el in categoryList"
        :key="el"
        :class="{ active: projectCategory === el }"
        @click="categoryTag(el)"
        >{{ el }}</span
      >
    </div>
    <div class="knowledge-project-list">
      <template v-if="projectList.length > 0">
        <div v-for="el in projectList" :key="el.id">
          <p style="cursor: pointer" @click="toProject(el)">
            <v-img
              :attachment-id="el.projectIcon"
              :default-img="require('@/assets/img/kctp.png')"
            />
            {{ el.projectName }}
          </p>
          <span>{{ el.projectDescription }}</span>
          <div>
            <p>
              <template v-for="(e, idx) in el.tags">
                {{ e }}
                <a-divider
                  v-if="idx < el.tags.length - 1"
                  type="vertical"
                  :key="e"
                />
              </template>
            </p>
            <!--            <span-->
            <!--              ><img src="@/assets/img/2.0/plicon.png" alt="图片" />{{-->
            <!--                el.viewCount-->
            <!--              }}</span-->
            <!--            >-->
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty />
      </template>
    </div>
    <div style="text-align: right">
      <a-pagination
        show-size-changer
        show-quick-jumper
        hide-on-single-page
        :current="pages.current"
        :total="pages.total"
        @change="paginationChange"
        @showSizeChange="showSizeChange"
      />
    </div>
  </div>
</template>

<script>
import {
  getOpenProjectCategory,
  getOpenProjectList,
} from "@/api/openKnowledge";
import VImg from "@/components/VImg";
export default {
  components: {
    VImg,
  },
  data() {
    return {
      pages: {
        total: 0,
        current: 1,
        size: 10,
      },
      projectCategory: null,
      categoryList: [],
      projectList: [],
    };
  },
  mounted() {
    this.openProjectList();
    this.openProjectCategory();
  },
  methods: {
    openProjectList() {
      getOpenProjectList(this.pages, {
        projectCategory: this.projectCategory,
        sortKey:'publish_time'
      }).then((res) => {
        console.log(res);
        this.projectList = res.records;
        this.pages.total = res.total;
      });
    },
    toProject(item) {
      if (!item.sourceUrl) {
        return;
      }
      window.open(item.sourceUrl);
    },
    openProjectCategory() {
      getOpenProjectCategory().then((res) => {
        this.categoryList = res;
      });
    },
    categoryTag(val) {
      this.pages.current = 1;
      this.projectCategory = val;
      this.openProjectList();
    },
    paginationChange(page, pageSize) {
      this.pages.current = page;
      this.openProjectList();
    },
    showSizeChange(current, size) {
      this.pages.size = size;
      this.openProjectList();
    },
  },
};
</script>

<style lang="scss" scoped>
.knowledge-project-box {
  .knowledge-project-tag {
    display: flex;
    margin-bottom: 8px;
    > span {
      font-size: 18px;
      color: #666666;
      line-height: 64px;
      margin-right: 40px;
      cursor: pointer;
      transition: all 0.3s;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: #262626;
        font-weight: bold;
      }
    }
  }
  .knowledge-project-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      width: 465px;
      background: #ffffff;
      padding: 24px;
      margin-bottom: 24px;
      > p {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 18px;
        color: #262626;
        line-height: 24px;
        margin-bottom: 16px;
        > img {
          width: 64px;
          height: 64px;
          margin-right: 16px;
        }
      }
      > span {
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        display: block;
        margin-bottom: 24px;
      }
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > p {
          font-size: 14px;
          color: #999999;
          line-height: 20px;
        }
        > span {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          > img {
            margin-right: 4px;
          }
        }
      }
    }
  }
}
</style>
